import { ColorModePicker } from '@pocket/web-ui'
import { CollapseWrapper } from './dev-tools'

export function Colors() {
  return (
    <CollapseWrapper title='Colors' collapsed>
      <ColorModePicker />
    </CollapseWrapper>
  )
}
